import { BaseFilter } from '../base-filter.interface'
import { DateRangeFilter } from '../shared/date-range-filter.interface'

export interface SmartQuoteFilter extends BaseFilter {
    customerId?: number
    dateRangeFilter?: DateRangeFilter
    status?: SmartQuoteStatusFilter
    searchTerm?: string
    emailSent?: boolean
}

export enum SmartQuoteStatusFilter {
    All = 0,
    Pending = 1,
    Declined = 2,
    Accepted = 3,
}
